'use client';

export const getUserFomStorage = () => {
  if (typeof localStorage !== 'undefined') {
    const user = localStorage?.getItem('user');
    return user ? JSON.parse(user) : undefined;
  }
  return undefined;
};

export const setUserInStorage = (user: unknown) => {
  if (typeof localStorage === 'undefined') {
    return;
  }
  localStorage.setItem('user', JSON.stringify(user));
};
